<!-- 奖金计算 -->
<template>
  <div class="">
    <yiheader></yiheader>
    <div class="clear"></div>
  </div>
  <router-view />
  <yifooter></yifooter>
</template>

<script>
  //import '../js/font.js' //js文件引入，注意路径
  //import {myfun} from '../js/test.js' //js文件引入，注意路径
  //import Introduction from '@/views/Introduction.vue'
  //import api from '@/js/method'
  import yiheader from "@/components/yilou/yi-header.vue";
  import yifooter from "@/components/Footer.vue";
  export default {
    name: "Number-select",
    components: {
      yiheader,
      yifooter,

    },
    data() {
      // 数据源
      return {};
    },
    mounted() {
      this.star()
    },
    computed: {
      // sd() {
      //     return this.$store.state.sd;
      // },
    },
    methods: {
      // 函数体部分，js的主要逻辑控制
      star() {
        document.documentElement.scrollTop = 0;
      }
    },
    props: {},
  };
</script>

<style scoped>
  /* @import './swiper.css'; */
  .clear {
    clear: both;
  }
</style>